<!-- 底部支付按钮 -->
<template>
  <div class="footer-pay">
    <div class="bar">
      <div class="total-price">
        <span class="total-text">合计：</span>
        <span class="total-symbol">￥</span>
        <span class="total-num">{{totalPrice}}</span>
      </div>
      <div class="pay-btn" @click="goPayment">确定支付</div>
    </div>
  </div>
</template>

<script>
import { genOrder } from '@/api/order'
import { login } from '@/utils/login'

export default {
  name: 'FooterPayBar',
  props: ['goodsInfo', 'orderPayBackPath'],
  data() {
    return {
      
    }
  },
  computed: {
    totalPrice: {
      get: function () {
        let priceLabel = this.goodsInfo && this.goodsInfo.price / 100 + '' || ''
        return (priceLabel.indexOf('.') >= 0) ? (+priceLabel).toFixed(2) : priceLabel + '.00'
      }
    }
  },
  methods: {
    goPayment() {
      // check login
      if (!this.$store.getters.token) {
        return login(window.location.href)
      }

      let goodsInfo = this.goodsInfo
      let discountList = []
      if (goodsInfo.discount_list) {
        goodsInfo.discount_list.forEach(item => {
          discountList.push({
            discountId: item.discount_id,
            discountPrice: item.discount_price,
            discountPriceLabel: item.discount_price_label,
            discountName: item.discount_name,
          })
        })
      }
      this.$store.dispatch('setOrderInfo', {
        goodsId: goodsInfo.id,
        goodsType: goodsInfo.type,
        content: goodsInfo.content,
        desc: goodsInfo.desc,
        name: goodsInfo.name,
        price: goodsInfo.price,
        priceLabel: goodsInfo.priceLabel,
        shareId: goodsInfo.shareId,
        account: goodsInfo.account || goodsInfo.priceLabel,
        discountDetail: {
          discountTotalPrice: goodsInfo.discount_total_price || 0,
          discountTotalPriceLabel: goodsInfo.discount_total_price_label || '',
          discountedPrice: goodsInfo.discounted_price || 0,
        },
        discountList: discountList,
      })
      let orderPayBackPath = encodeURIComponent(this.orderPayBackPath|| '/buyvip')
      this.$router.push({ path: 'order', query: { order_payback_url: orderPayBackPath } })
    }
  }
}
</script>

<style lang="less" scoped>
  .footer-pay {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    padding-top: .2rem;
    width: 100%;
    overflow: hidden;
  }
  .bar {
    display: flex;
    align-items: center;
    width: 100%;
    height: 1.2rem;
    font-size: .34rem;
    font-weight: bold;
    color: #6c6c74;
    background: #fff;
    box-shadow: 0 0 12px rgba(44,42,64,.08);
  }
  .total-price {
    flex: 1;
    padding-left: .4rem;
  }
  .pay-btn {
    text-align: center;
    width: 2.56rem;
    height: 100%;
    line-height: 1.2rem;
    color: #604038;
    background: linear-gradient(-134deg, #FEB800, #F8DD61);
  }
</style>
